export default {
    data() {
        return {
            refreshKey: 0
        }
    },

    computed: {
        linkOut() {
            this.refreshKey;

            if (! this.email) {
                return null;
            }

            if (! this.referral) {
                return null;
            }

            let linkOut = 'google-widget';

            window.feedback_link_out.every(config => {
                let non = false, url = null;
                let [domain, frequency, urls] = config.split(',');

                // URLs delimited by semi-colon to allow for random use...
                urls = urls.split(';');

                url = urls[Math.floor(Math.random()*urls.length)];

                // Determine if it's a non: usage...
                if (domain.indexOf('non:') !== -1) {
                    non = true;
                    [, domain] = domain.split(':');
                }

                console.log(this.email);
                console.log(domain);
                console.log(frequency);
                console.log(urls);
                console.log(non);

                let chance = Math.random() * 100;

                if (domain === 'any') {
                    if (frequency === '100%') {
                        linkOut = url;

                        console.log('1');

                        return false;
                    } else if (chance < frequency.substring(0, (frequency.length - 1))) {
                        linkOut = url;

                        console.log('2');

                        return false;
                    }
                } else if (! non && this.email.indexOf(domain) !== -1) {
                    if (frequency === '100%') {
                        linkOut = url;

                        console.log('3');

                        return false;
                    } else if (chance < frequency.substring(0, (frequency.length - 1))) {
                        linkOut = url;

                        console.log('4');

                        return false;
                    }
                } else if (non && this.email.indexOf(domain) === -1) {
                    if (frequency === '100%') {
                        linkOut = url;

                        console.log('5');

                        return false;
                    } else if (chance < frequency.substring(0, (frequency.length - 1))) {
                        linkOut = url;

                        console.log('6');

                        return false;
                    }
                }

                console.log('7');

                return true;
            });

            return linkOut;
        }
    }
}